import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  duration: number;
  onComplete: () => void;
}

const Timer: React.FC<Props> = ({ duration, onComplete }) => {
  const { t } = useTranslation();
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    setRemaining(duration);
  }, [duration]);

  useEffect(() => {
    if (remaining <= 0) { onComplete(); return; }
    const timer = setTimeout(() => setRemaining(remaining - 1), 1000);
    return () => clearTimeout(timer);
  }, [remaining, onComplete]);

  const percentage = (remaining / duration) * 100;
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;

  const getColor = () => {
    if (percentage > 50) return '#10B981';
    if (percentage > 25) return '#F59E0B';
    return '#EF4444';
  };

  return (
    <div className="flex justify-center items-center">
      <div className="relative w-32 h-32">
        <svg className="transform -rotate-90 w-32 h-32">
          <circle cx="64" cy="64" r="45" stroke="#E5E7EB" strokeWidth="8" fill="none" />
          <circle
            cx="64" cy="64" r="45"
            stroke={getColor()}
            strokeWidth="8"
            fill="none"
            strokeDasharray={2 * Math.PI * 45}
            strokeDashoffset={2 * Math.PI * 45 * (1 - percentage / 100)}
            strokeLinecap="round"
            className="transition-all duration-1000 ease-linear"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="text-3xl font-bold text-gray-800">
              {minutes}:{seconds.toString().padStart(2, '0')}
            </div>
            <div className="text-xs text-gray-500 mt-1">{t('test.remaining')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timer;
